/* eslint-disable max-len */

export const FETCHING_FLOATING_INVENTORY_SUMMARY = '@@toyota/FETCHING_FLOATING_INVENTORY_SUMMARY';
export const FETCHED_FLOATING_INVENTORY_SUMMARY = '@@toyota/FETCHED_FLOATING_INVENTORY_SUMMARY';
export const FETCHED_FLOATING_INVENTORY_SUMMARY_FAILED = '@@toyota/FETCHED_FLOATING_INVENTORY_SUMMARY_FAILED';

export const FETCHING_NOT_PRIORIZED_VEHICLES = '@@toyota/FETCHING_NOT_PRIORIZED_VEHICLES';
export const FETCHED_NOT_PRIORIZED_VEHICLES = '@@toyota/FETCHED_NOT_PRIORIZED_VEHICLES';
export const FETCHED_NOT_PRIORIZED_VEHICLES_FAILED = '@@toyota/FETCHED_NOT_PRIORIZED_VEHICLES_FAILED';

export const FETCHING_FLOATING_INVENTORY = '@@toyota/FETCHING_FLOATING_INVENTORY';
export const FETCHED_FLOATING_INVENTORY = '@@toyota/FETCHED_FLOATING_INVENTORY';
export const FETCHED_FLOATING_INVENTORY_FAILED = '@@toyota/FETCHED_FLOATING_INVENTORY_FAILED';

export const FETCHING_FLOATING_INVENTORY_REPORT = '@@toyota/FETCHING_FLOATING_INVENTORY_REPORT';
export const FETCHED_FLOATING_INVENTORY_REPORT = '@@toyota/FETCHED_FLOATING_INVENTORY_REPORT';
export const FETCHED_FLOATING_INVENTORY_REPORT_FAILED = '@@toyota/FETCHED_FLOATING_INVENTORY_REPORT_FAILED';

export const DELETING_FLOATING_INVENTORY = '@@toyota/DELETING_FLOATING_INVENTORY';
export const DELETED_FLOATING_INVENTORY = '@@toyota/DELETED_FLOATING_INVENTORY';
export const DELETED_FLOATING_INVENTORY_FAILED = '@@toyota/DELETED_FLOATING_INVENTORY_FAILED';

export const FETCHING_ADVISERS_LIST = '@@toyota/FETCHING_ADVISERS_LIST';
export const FETCHED_ADVISERS_LIST = '@@toyota/FETCHED_ADVISERS_LIST';
export const FETCHED_ADVISERS_LIST_FAILED = '@@toyota/FETCHED_ADVISERS_LIST_FAILED';

export const FETCHING_PUT_FLOATING_INVENTORY = '@@toyota/FETCHING_PUT_FLOATING_INVENTORY';
export const FETCHED_PUT_FLOATING_INVENTORY = '@@toyota/FETCHED_PUT_FLOATING_INVENTORY';
export const FETCHED_PUT_FLOATING_INVENTORY_FAILED = '@@toyota/FETCHED_PUT_FLOATING_INVENTORY_FAILED';

export const FETCHING_EX_PERCENTAJES_FL_INVENTORY = '@@toyota/FETCHING_EX_PERCENTAJES_FL_INVENTORY';
export const FETCHED_EX_PERCENTAJES_FL_INVENTORY = '@@toyota/FETCHED_EX_PERCENTAJES_FL_INVENTORY';
export const FETCHED_EX_PERCENTAJES_FL_INVENTORY_FAILED = '@@toyota/FETCHED_EX_PERCENTAJES_FL_INVENTORY_FAILED';

export const FETCHING_FLOAT_CLIENT_INFO = '@@toyota/FETCHING_FLOAT_CLIENT_INFO';
export const FETCHED_FLOAT_CLIENT_INFO = '@@toyota/FETCHED_FLOAT_CLIENT_INFO';
export const FETCHED_FLOAT_CLIENT_INFO_FAILED = '@@toyota/FETCHED_FLOAT_CLIENT_INFO_FAILED';


export const SET_CURRENT_FLOATING_LINE = '@@toyota/SET_CURRENT_FLOATING_LINE';
export const CLEAN_FLOAT_CLIENT_LINE = '@@toyota/CLEAN_FLOAT_CLIENT_LINE';
export const SET_BLOCK_FLOATING_TABLE = '@@toyota/SET_BLOCK_FLOATING_TABLE';

export const UPDATE_CURRENT_FLOATING_LINE = '@@toyota/UPDATE_CURRENT_FLOATING_LINE';
export const UPDATE_CURRENT_FLOATING_LINE_ERROR = '@@toyota/UPDATE_CURRENT_FLOATING_LINE_ERROR';

export const CLEAN_CURRENT_LINE_DATA_FLOATING = '@@toyota/CLEAN_CURRENT_LINE_DATA_FLOATING';

export const SET_CURRENT_LINE_ERROR_FLOATING = '@@toyota/SET_CURRENT_LINE_ERROR_FLOATING';

export const DUMMY_ACTION_FLOATING = '@@toyota/DUMMY_ACTION_FLOATING';

export const SET_CURRENT_FLOATING_ORDER_CLIENT = '@@toyota/SET_CURRENT_FLOATING_ORDER_CLIENT';

export const FETCHING_FLOAT_CLIENT_AUDIT = '@@toyota/FETCHING_FLOAT_CLIENT_AUDIT';
export const FETCHED_FLOAT_CLIENT_AUDIT = '@@toyota/FETCHED_FLOAT_CLIENT_AUDIT';
export const FETCHED_FLOAT_CLIENT_AUDIT_FAILED = '@@toyota/FETCHED_FLOAT_CLIENT_AUDIT_FAILED';

export const FETCHING_FLOAT_INVENTORY_AUDIT = '@@toyota/FETCHING_FLOAT_INVENTORY_AUDIT';
export const FETCHED_FLOAT_INVENTORY_AUDIT = '@@toyota/FETCHED_FLOAT_INVENTORY_AUDIT';
export const FETCHED_FLOAT_INVENTORY_AUDIT_FAILED = '@@toyota/FETCHED_FLOAT_INVENTORY_AUDIT_FAILED';

export const CHANGE_CURRENT_SCREEN_FLOAT_AUDIT = '@@toyota/CHANGE_CURRENT_SCREEN_FLOAT_AUDIT';
export const CLEAN_FLOATING_AUDIT_SCREEN = '@@toyota/CLEAN_FLOATING_AUDIT_SCREEN';

export const FETCHING_FLOAT_CLIENT_AUDIT_LIST_DOCUMENT = '@@toyota/FETCHING_FLOAT_CLIENT_AUDIT_LIST_DOCUMENT';
export const FETCHED_FLOAT_CLIENT_AUDIT_LIST_DOCUMENT = '@@toyota/FETCHED_FLOAT_CLIENT_AUDIT_LIST_DOCUMENT';
export const FETCHED_FLOAT_CLIENT_AUDIT_LIST_DOCUMENT_FAILED = '@@toyota/FETCHED_FLOAT_CLIENT_AUDIT_LIST_DOCUMENT_FAILED';

export const FETCHING_FLOAT_CLIENT_AUDIT_LIST_NAMES = '@@toyota/FETCHING_FLOAT_CLIENT_AUDIT_LIST_NAMES';
export const FETCHED_FLOAT_CLIENT_AUDIT_LIST_NAMES = '@@toyota/FETCHED_FLOAT_CLIENT_AUDIT_LIST_NAMES';
export const FETCHED_FLOAT_CLIENT_AUDIT_LIST_NAMES_FAILED = '@@toyota/FETCHED_FLOAT_CLIENT_AUDIT_LIST_NAMES_FAILED';

export const FETCHING_FLOAT_CLIENT_AUDIT_LIST_LAST_NAMES = '@@toyota/FETCHING_FLOAT_CLIENT_AUDIT_LIST_LAST_NAMES';
export const FETCHED_FLOAT_CLIENT_AUDIT_LIST_LAST_NAMES = '@@toyota/FETCHED_FLOAT_CLIENT_AUDIT_LIST_LAST_NAMES';
export const FETCHED_FLOAT_CLIENT_AUDIT_LIST_LAST_NAMES_FAILED = '@@toyota/FETCHED_FLOAT_CLIENT_AUDIT_LIST_LAST_NAMES_FAILED';

export const FETCHING_FLOAT_INVENTORY_AUDIT_LIST_ORDER = '@@toyota/FETCHING_FLOAT_INVENTORY_AUDIT_LIST_ORDER';
export const FETCHED_FLOAT_INVENTORY_AUDIT_LIST_ORDER = '@@toyota/FETCHED_FLOAT_INVENTORY_AUDIT_LIST_ORDER';
export const FETCHED_FLOAT_INVENTORY_AUDIT_LIST_ORDER_FAILED = '@@toyota/FETCHED_FLOAT_INVENTORY_AUDIT_LIST_ORDER_FAILED';

export const FETCHING_FLOAT_INVENTORY_AUDIT_LIST_CHASSIS = '@@toyota/FETCHING_FLOAT_INVENTORY_AUDIT_LIST_CHASSIS';
export const FETCHED_FLOAT_INVENTORY_AUDIT_LIST_CHASSIS = '@@toyota/FETCHED_FLOAT_INVENTORY_AUDIT_LIST_CHASSIS';
export const FETCHED_FLOAT_INVENTORY_AUDIT_LIST_ORDER_CHASSIS = '@@toyota/FETCHED_FLOAT_INVENTORY_AUDIT_LIST_ORDER_CHASSIS';

export const FETCHING_VEHICLES_ORDERS_LIST = '@@toyota/FETCHING_VEHICLES_ORDERS_LIST';
export const FETCHED_VEHICLES_ORDERS_LIST = '@@toyota/FETCHED_VEHICLES_ORDERS_LIST';
export const FETCHED_VEHICLES_ORDERS_LIST_FAILED = '@@toyota/FETCHED_VEHICLES_ORDERS_LIST_FAILED';

export const SET_CURRENT_FLOATING_USER_GROUP = '@@toyota/SET_CURRENT_FLOATING_USER_GROUP';
export const CLEAN_FLOATING_INVENTORY_REPORT = '@@toyota/CLEAN_FLOATING_INVENTORY_REPORT';
export const SET_IS_NOT_PRIORIZED_MODAL_OPEN = '@@toyota/SET_IS_NOT_PRIORIZED_MODAL_OPEN';
export const SET_FLOATING_DATA_WAS_SHOWN = '@@toyota/SET_FLOATING_DATA_WAS_SHOWN';

export const FETCHING_FLOAT_INVENTORY_AUDIT_EXCEL = '@@toyota/FETCHING_FLOAT_INVENTORY_AUDIT_EXCEL';
export const FETCHED_FLOAT_INVENTORY_AUDIT_EXCEL = '@@toyota/FETCHED_FLOAT_INVENTORY_AUDIT_EXCEL';
export const FETCHED_FLOAT_INVENTORY_AUDIT_EXCEL_FAILED = '@@toyota/FETCHED_FLOAT_INVENTORY_AUDIT_EXCEL_FAILED';
export const CLEAR_FLOAT_INVENTORY_AUDIT_EXCEL = '@@toyota/CLEAR_FLOAT_INVENTORY_AUDIT_EXCEL';

export const FETCHING_FLOAT_CLIENT_INVENTORY_AUDIT_EXCEL = '@@toyota/FETCHING_FLOAT_CLIENT_INVENTORY_AUDIT_EXCEL';
export const FETCHED_FLOAT_INVENTORY_CLIENT_AUDIT_EXCEL = '@@toyota/FETCHED_FLOAT_INVENTORY_CLIENT_AUDIT_EXCEL';
export const FETCHED_FLOAT_INVENTORY_CLIENT_AUDIT_EXCEL_FAILED = '@@toyota/FETCHED_FLOAT_INVENTORY_CLIENT_AUDIT_EXCEL_FAILED';
